// @ts-expect-error no declaration file
import { emojiIndex } from 'emoji-mart';
import Raven from 'raven-js';
import { createSuggestionPlugin } from './index';
const skinToneBaseRe = new RegExp('\\p{Emoji_Modifier_Base}', 'gu');
const allowedSearchRe = /^[\w-+]+$/;
const getSkinTone = () => {
  const LOCAL_STORAGE_KEY = 'emoji-mart.skin';
  const skinTones = new Map([['1', ''], ['2', '\u{1f3fb}'], ['3', '\u{1f3fc}'], ['4', '\u{1f3fd}'], ['5', '\u{1f3fe}'], ['6', '\u{1f3ff}']]);
  try {
    const tone = localStorage.getItem(LOCAL_STORAGE_KEY) || '1';
    return skinTones.get(tone) || '';
  } catch (error) {
    Raven.captureException(error, {
      extra: {
        LOCAL_STORAGE_KEY
      }
    });
    return '';
  }
};

// Factory function creates a new plugin instance per call. This is required for
// multi-editor support - a singleton would share dropdown state across editors,
// causing popovers to flash/disappear when switching between editors.
export function createEmojiPlugin(emojiConfig) {
  const onOpenPopover = emojiConfig === null || emojiConfig === void 0 ? void 0 : emojiConfig.onOpenPopover;
  const onClosePopover = emojiConfig === null || emojiConfig === void 0 ? void 0 : emojiConfig.onClosePopover;
  return createSuggestionPlugin({
    allowSpace: false,
    getSuggestions(text, callback) {
      if (!allowedSearchRe.test(text)) {
        callback([]);
        return;
      }
      const selectedSkinTone = getSkinTone();
      const results = emojiIndex.search(text).map(emoji => applySkinTone(emoji, selectedSkinTone)).map(e => {
        return {
          // @ts-expect-error id doesn't really need to be a number
          id: e.id,
          searchText: `${e.native} ${e.id}`,
          text: e.native
        };
      });
      callback(results);
    },
    type: 'EMOJI',
    leftOffset: emojiConfig === null || emojiConfig === void 0 ? void 0 : emojiConfig.leftOffset,
    width: emojiConfig === null || emojiConfig === void 0 ? void 0 : emojiConfig.width,
    onOpenPopover: onOpenPopover ? () => onOpenPopover({
      type: 'inline'
    }) : undefined,
    onClosePopover: onClosePopover ? () => onClosePopover({
      type: 'inline'
    }) : undefined,
    suggestionsPlacement: emojiConfig === null || emojiConfig === void 0 ? void 0 : emojiConfig.suggestionsPlacement
  });
}

/** @deprecated Use createEmojiPlugin() instead for multi-editor support */
export const EmojiPlugin = createEmojiPlugin();
export function applySkinTone(emoji, selectedSkinTone) {
  const matches = emoji.native.match(skinToneBaseRe);
  return matches && matches.length === 1 ? Object.assign({}, emoji, {
    native: emoji.native.replace(matches[0], matches[0] + selectedSkinTone)
  }) : emoji;
}